<style>
  .color-picker .vs-inputx{
    height: 50px;
    width: 50px;
  } 
</style>
<template>
  <div>
    <vx-card>
      <div class="vx-row">
        <div class="vx-col w-full sm:w-1/2 pt-8">
          <vs-input class="w-full" :label="$t('Labels.Name')" :placeholder="$t('Labels.Name')" v-model="circuit.name"/>
        </div>
        <div class="vx-col w-full sm:w-1/2 pt-4">
          <vs-input class="inline-block ml-2 w-auto color-picker" :label="$t('Labels.Color')" v-model="circuit.color" type="color"/>
        </div>
      </div>
      <div class="vx-col w-full text-center sm:text-right">
        <vs-button @click="add()" color="primary" class="mr-2 mt-6" :disabled="!valid">{{$t('Labels.Add')}}</vs-button>
        <vs-button @click="reset()" color="danger" type="border" class="bg-white mt-6">{{$t('Labels.Clean')}}</vs-button>
      </div>
    </vx-card>
  </div>
</template>
<script>
import {request} from '@/request.js'
import {empty} from '@/helpers.js'
import {globalPassActions} from '@/globalPass'

export default {
  data () {
    return {
      circuit:{
        name: '',
        color: ''
      }
    }
  },

  methods: {
    requestPassword () {
      globalPassActions.show()
    },
    async add () {

      const params = {
        url: 'luminaires_circuits',
        method: 'POST',
        params: this.circuit
      }
      await request(params).then(() => {
        window.location.href = '/circuitos'
      })       
    }

  },
  created () {
  },
  computed: {
    valid () {
      if (!empty(this.circuit.name) && !empty(this.circuit.color)) return true
      else return false
    } 
  }
}
</script>

